import {
  Box,
  Button,
  FormControl,
  Grid,
  makeStyles,
  Paper,
  Select,
  Typography,
} from "@material-ui/core";
import { Add } from "@material-ui/icons";
import { Skeleton } from "@material-ui/lab";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { backend } from "../../../../api";
import AddBook from "./Modals/AddBook";
import { MdFilterList } from "react-icons/md";
import BookList from "./BookList";

const useStyles = makeStyles((theme) => ({
  root: {
    border: `1px solid ${theme.palette.secondary.dark}`,
    borderRadius: "5px",
    marginTop: "30px",
    padding: "10px",
    [theme.breakpoints.down("md")]: {
      marginTop: "30px",
    },
  },
  tabHeading: {
    fontSize: "32px",
    fontWeight: 550,
    margin: "0",
  },
  userName: {
    color: theme.palette.primary.dark,
    fontSize: 22,
    fontWeight: 500,
  },
  subHead: {
    margin: 0,
    fontSize: 18,
    fontWeight: 550,
    width: "170px",
  },
  contactBox: {
    display: "flex",
    flexWrap: "wrap",
    padding: "8px 0",
    margin: "0px",
    borderBottom: `1px solid ${theme.palette.secondary.dark}`,
  },
}));

function Products(props) {
  const classes = useStyles();
  const { user } = props;
  const history = useHistory();
  const [books, setBooks] = useState();
  const [bookList, setBookList] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchAuthorBooks();
  }, []);

  const fetchAuthorBooks = () => {
    setLoading(true);

    backend
      .get(`/adverbook?author=${user?.author?._id}`)
      .then((res) => {
        setBooks(res.data.data);
        setBookList(
          res.data.data.filter(
            (book) => book.status?.slice(-1)[0]?.status === "approved"
          )
        );
      })
      .catch((err) => {
        toast.error(err.response ? err.response.data.message : err.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleFilterProducts = (e) => {
    if (e.target.value === "approved") {
      setBookList(
        books.filter((book) => book.status?.slice(-1)[0]?.status === "approved")
      );
    } else if (e.target.value === "pending") {
      setBookList(
        books.filter((book) => book.status?.slice(-1)[0]?.status === "pending")
      );
    } else if (e.target.value === "inactive") {
      setBookList(
        books.filter((book) => book.status?.slice(-1)[0]?.status === "declined")
      );
    } else {
      setBookList(books);
    }
  };

  return (
    <div className={classes.root}>
      <h2 className={classes.tabHeading}>My KleverBooks</h2>

      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={4}
      >
        <Button
  variant="outlined"
  startIcon={<Add />}
  onClick={() => history.push("/author/add", { addToKlever: true })}
>
  Add KleverBook
</Button>
        <FormControl
          variant="outlined"
          className={classes.filterSelect}
          startIcon={<MdFilterList />}
        >
          <Select native onChange={handleFilterProducts}>
            <option value="approved">Approved</option>
            <option value="inactive">Declined</option>
            <option value="pending">Unapproved</option>
          </Select>
        </FormControl>
      </Box>
      {bookList && Boolean(bookList.length) ? (
        <BookList books={bookList} />
      ) : loading === true ? (
        <Box>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4} lg={3}>
              <Paper elevation={2} className={classes.paper}>
                <Skeleton
                  variant="rect"
                  width={200}
                  height={300}
                  animation="wave"
                  style={{ margin: "0 auto" }}
                />
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
              </Paper>
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <Paper elevation={2} className={classes.paper}>
                <Skeleton
                  variant="rect"
                  width={200}
                  height={300}
                  animation="wave"
                  style={{ margin: "0 auto" }}
                />
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
              </Paper>
            </Grid>
            <Grid item xs={12} md={4} lg={3}>
              <Paper elevation={2} className={classes.paper}>
                <Skeleton
                  variant="rect"
                  width={200}
                  height={300}
                  animation="wave"
                  style={{ margin: "0 auto" }}
                />
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
              </Paper>
            </Grid>
          </Grid>
        </Box>
      ) : (
        <Box>
          <Typography
            variant="h2"
            color="error"
            style={{ margin: "30px auto" }}
          >
            No KleverBooks.
          </Typography>
        </Box>
      )}
    </div>
  );
}

export default Products;
